import { objectValues } from '@orus.eu/utils'

import type { FrRcpaxeSegment } from '../fr-rcpaxe-activity-configuration.ts'
import type { FrRcpaxeCsRcpSegment } from '../fr-rcpaxe-document-composition.ts'
import type { FrRcpaxeStaticFileIdFormat } from '../model.ts'

// Axeria's general terms, special conventions and IPIDs (October 2026). They replaced copies of fr-rcpw's documents under
// the same ids, before the product was released.
export const frRcpaxeBaseGeneralTermsStaticFileId_v1_0_0 =
  'fr-rcpaxe-base-general-terms-v1_0_0' as const satisfies FrRcpaxeStaticFileIdFormat

export const frRcpaxeCsRceGeneralTermsStaticFileId_v1_0_0 =
  'fr-rcpaxe-cs-rce-general-terms-v1_0_0' as const satisfies FrRcpaxeStaticFileIdFormat

/** COM ships a single combined document standing in for CG + CS RCE + CS RCP. */
export const frRcpaxeComGeneralTermsStaticFileId_v1_0_0 =
  'fr-rcpaxe-com-general-terms-v1_0_0' as const satisfies FrRcpaxeStaticFileIdFormat

export const frRcpaxeRceIpidStaticFileId_v1_0_0 =
  'fr-rcpaxe-rce-ipid-v1_0_0' as const satisfies FrRcpaxeStaticFileIdFormat

export const frRcpaxeCsRcpGeneralTermsStaticFileIdBySegment_v1_0_0 = {
  BIE: 'fr-rcpaxe-bie-cs-rcp-general-terms-v1_0_0',
  MAC: 'fr-rcpaxe-mac-cs-rcp-general-terms-v1_0_0',
  MAN: 'fr-rcpaxe-man-cs-rcp-general-terms-v1_0_0',
  MED: 'fr-rcpaxe-med-cs-rcp-general-terms-v1_0_0',
  MISC: 'fr-rcpaxe-misc-cs-rcp-general-terms-v1_0_0',
  SECU: 'fr-rcpaxe-secu-cs-rcp-general-terms-v1_0_0',
  TECH: 'fr-rcpaxe-tech-cs-rcp-general-terms-v1_0_0',
} as const satisfies Record<FrRcpaxeCsRcpSegment, FrRcpaxeStaticFileIdFormat>

/** AUTO reuses the MISC IPID, so it has no dedicated entry here. */
type FrRcpaxeIpidSegment = Exclude<FrRcpaxeSegment, 'AUTO'>

export const frRcpaxeIpidStaticFileIdBySegment_v1_0_0 = {
  BIE: 'fr-rcpaxe-bie-ipid-v1_0_0',
  COM: 'fr-rcpaxe-com-ipid-v1_0_0',
  MAC: 'fr-rcpaxe-mac-ipid-v1_0_0',
  MAN: 'fr-rcpaxe-man-ipid-v1_0_0',
  MED: 'fr-rcpaxe-med-ipid-v1_0_0',
  MISC: 'fr-rcpaxe-misc-ipid-v1_0_0',
  SECU: 'fr-rcpaxe-secu-ipid-v1_0_0',
  TECH: 'fr-rcpaxe-tech-ipid-v1_0_0',
} as const satisfies Record<FrRcpaxeIpidSegment, FrRcpaxeStaticFileIdFormat>

export const frRcpaxeStaticFilesIds_v1_0_0 = [
  frRcpaxeBaseGeneralTermsStaticFileId_v1_0_0,
  frRcpaxeCsRceGeneralTermsStaticFileId_v1_0_0,
  frRcpaxeComGeneralTermsStaticFileId_v1_0_0,
  ...objectValues(frRcpaxeCsRcpGeneralTermsStaticFileIdBySegment_v1_0_0),
  ...objectValues(frRcpaxeIpidStaticFileIdBySegment_v1_0_0),
  frRcpaxeRceIpidStaticFileId_v1_0_0,
] as const satisfies readonly FrRcpaxeStaticFileIdFormat[]
